var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUsersPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52734 9.38744C5.52734 11.4348 6.34061 13.3982 7.78823 14.8459C9.23585 16.2936 11.1992 17.1069 13.2465 17.1069C15.2937 17.1069 17.2571 16.2936 18.7047 14.8459C20.1524 13.3982 20.9656 11.4348 20.9656 9.38744C20.9656 7.34011 20.1524 5.37663 18.7047 3.92895C17.2571 2.48127 15.2937 1.66797 13.2465 1.66797C11.1992 1.66797 9.23585 2.48127 7.78823 3.92895C6.34061 5.37663 5.52734 7.34011 5.52734 9.38744Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 36.4034V32.5437C1.66797 30.4964 2.48123 28.5329 3.92885 27.0852C5.37647 25.6375 7.33987 24.8242 9.38711 24.8242H17.1063C18.9588 24.8242 20.6571 25.4765 21.9886 26.563",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7539 1.91992C28.4143 2.34507 29.886 3.31078 30.937 4.66479C31.9879 6.01881 32.5584 7.68411 32.5584 9.39816C32.5584 11.1122 31.9879 12.7775 30.937 14.1315C29.886 15.4855 28.4143 16.4512 26.7539 16.8764",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7539 32.5469H38.3326",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.543 26.7539V38.3331",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersPlus);
export default __webpack_public_path__ + "static/media/icon_users_plus.a9e01c1c93a50d8581e21dd5c0ba86d5.svg";
export { ForwardRef as ReactComponent };